export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-black mb-4">学習塾NICK</h3>
            <p className="text-sm text-blue-100 leading-relaxed">
              広島県廿日市市大野の学習塾<br />
              中学1年生・中学2年生・中学３年生<br />
              完全個別指導・定期テスト対策あり
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">お問い合わせ</h4>
            <ul className="space-y-2 text-sm text-blue-100">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>0829-78-1638</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>平日 16:00-21:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>土曜 14:00-20:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>広島県廿日市市大野</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">対応エリア</h4>
            <p className="text-sm text-blue-100 leading-relaxed mb-4">
              廿日市市・大竹市全域<br />
              その他近隣地域もご相談ください
            </p>
            <h4 className="text-lg font-bold mb-2">対象学年</h4>
            <p className="text-sm text-blue-100">
              中学生・高校生
            </p>
          </div>
        </div>

        <div className="border-t border-blue-700 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-blue-200">
              © 2025 学習塾NICK. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="nofollow noopener noreferrer"
              className="text-sm text-blue-200 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
